import { validateLTLForm } from '../../utils/validation';
import {
  BatchLTLMissingField,
  BatchLTLShipmentInput,
  BatchLTLShipmentValidation,
} from '../types';

const MISSING_FIELD_ORDER = Object.values(BatchLTLMissingField);

// The options the single form uses when Tai is the active LTL TMS.
export const BATCH_LTL_VALIDATION_OPTIONS = {
  acceptFullStreetLocations: true,
  validateFreightClassAgainstDropdown: true,
  validateTaiPickupDeliveryWindows: true,
};

// Same required fields as the single Tai LTL form, collected instead of set on the form.
export function validateBatchLTLShipment(
  shipment: BatchLTLShipmentInput
): BatchLTLShipmentValidation {
  const errors = validateLTLForm(
    shipment,
    () => undefined,
    BATCH_LTL_VALIDATION_OPTIONS
  );

  const missing = new Set(
    errors.map(([path]) => getMissingFieldForPath(String(path)))
  );

  return {
    isValid: errors.length === 0,
    missingFields: MISSING_FIELD_ORDER.filter((field) => missing.has(field)),
    errorPaths: new Set(errors.map(([path]) => String(path))),
  };
}

function getMissingFieldForPath(path: string): BatchLTLMissingField {
  if (path === 'stops.0.location') {
    return BatchLTLMissingField.Origin;
  }

  if (path.startsWith('stops.')) {
    return BatchLTLMissingField.Destination;
  }

  if (path.endsWith('.weight')) {
    return BatchLTLMissingField.Weight;
  }

  if (path.endsWith('.freightClass')) {
    return BatchLTLMissingField.FreightClass;
  }

  if (path.endsWith('.pieces') || path.endsWith('.handlingUnits')) {
    return BatchLTLMissingField.Pieces;
  }

  if (path.endsWith('.description')) {
    return BatchLTLMissingField.Description;
  }

  if (path.startsWith('ltl.selectedAccessorials')) {
    return BatchLTLMissingField.AccessorialDetails;
  }

  if (path === 'ltl.items') {
    return BatchLTLMissingField.Items;
  }

  return BatchLTLMissingField.PickupWindow;
}
